import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookOpen, Award } from 'lucide-react';

export const StatsGrid: React.FC = () => {
  const { t } = useTranslation();

  const items = [
    { icon: BookOpen, labelKey: 'landing.stats.examSections', value: '4' },
    { icon: Award, labelKey: 'landing.stats.levels', value: 'A2 & B1' },
  ];

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
      {items.map((item, index) => {
        const Icon = item.icon;
        return (
          <div key={index} className="surface-card p-7 text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
              <Icon className="h-7 w-7 text-primary" />
            </div>
            <div className="mb-1 text-3xl font-bold text-ink">{item.value}</div>
            <div className="font-medium text-slate-600">{t(item.labelKey)}</div>
          </div>
        );
      })}
    </div>
  );
};
